import { FC } from 'react'

import Box from '@mui/material/Box'

import { CredentialsProvider, ForgotPasswordType, SignInType } from './useLogin/useCredentials'
import { LoginContainer } from './LoginContainer'
import { LogoContainer } from './LogoContainer'

export type LoginViewProps = {
  signIn: SignInType
  forgotPassword: ForgotPasswordType
}

export const LoginView: FC<LoginViewProps> = ({ signIn, forgotPassword }) => {
  return (
    <Box sx={{ height: '100vh', width: '100wv', display: 'flex' }}>
      <LogoContainer />
      <CredentialsProvider signIn={signIn} forgotPassword={forgotPassword}>
        <LoginContainer />
      </CredentialsProvider>
    </Box>
  )
}
